/*
	© 2017 NetSuite Inc.
	User may not copy, modify, distribute, or re-bundle or otherwise make available this code;
	provided, however, if you are an authorized user with a NetSuite account or log-in, you
	may use this code subject to the terms that govern your access and use.
*/

//@module ReorderItems
define(
	'ReorderItems.Actions.Quantity.View'
,	[	'reorder_items_actions_quantity.tpl'

	,	'Backbone'
	,	'Backbone.CompositeView'
	,	'jQuery'
	,	'Profile.Model'
	,	'underscore'
	]
,	function (
		reorder_items_actions_quantity_tpl

	,	Backbone
	,	BackboneCompositeView
	,	jQuery
	,	ProfileModel
	,	_
	)
{
	'use strict';
	//@class ReorderItems.Actions.Quantity.View @extends Backbone.View
	return Backbone.View.extend({

		//@propery {Function} template
		template: reorder_items_actions_quantity_tpl

		//@method initialize
	,	initialize: function (options)
		{
			this.line = options.model;
			this.line.get('item').on('change:unitstype',this.render,this);
			
			// customization for wishlist ///
			var profile = ProfileModel.getInstance();
			var custFlds = profile.get('customfields') || profile.attributes.customfields;
			this.isIvaluaLogin = false;
			if(custFlds && custFlds != null && custFlds != '' && custFlds != undefined)
			{
				var ivaluaLogin = '';
				for(var c=0; custFlds.length > 0 && c < custFlds.length; c++)
				{
					var fld = custFlds[c];
					if(fld.name == 'custentity_appf_ivalua_punchout')
						ivaluaLogin = fld.value;
				}
				if(ivaluaLogin !== '')
				{
					this.isIvaluaLogin = true;
				}
			}
			/// customization for wishlist ///
			BackboneCompositeView.add(this);
		}

	,	events:{
			'click [data-action="plus"]': 'addQuantity'
		,	'click [data-action="minus"]': 'subQuantity'
		,	'change [name="unitstype"]': 'setUnitstype'
		}

	,	addQuantity: function (e)
		{
			e.preventDefault();

			var $element = jQuery(e.target)
			,	oldValue = $element.parent().find('input').val()
			,	newVal = parseFloat(oldValue) + 1;

			$element.parent().find('input').val(newVal);
		}

	,	subQuantity: function (e)
		{
			e.preventDefault();

			var $element = jQuery(e.target)
			,	oldValue = $element.parent().find('input').val()
			,	newVal = parseFloat(oldValue) - 1;

			newVal = Math.max(1,newVal);

			$element.parent().find('input').val(newVal);
		}
		
	,	setUnitstype: function(e)
		{
			/// customization for wishlist in leafreak///
			if(this.isIvaluaLogin){
				e.stopPropagation();
				
				var cartOptionId = jQuery(e.target).data('cart-option-id')
				,	value = jQuery(e.target).find('option:selected').val()
				,	text = jQuery(e.target).find('option:selected').text().trim()
				,	saleUnitObj = _.findWhere(this.model.get('item').get('unitstype'), {saleUnit: true})
				,	unitstype = _.findWhere(this.model.get('item').get('unitstype'), {id: value})
				,	self = this
				,	customprice;
				
				_.each(this.model.get('item').get('unitstype'), function(unit){
					if(unit.id == value)
					{
						var newprice = (self.model.getPrice().price/saleUnitObj.convertionRate) * unit.convertionRate;
						customprice = newprice.toString();
					}
				});

				if(this.model.get('item').get('unitstype') && this.model.get('item').get('unitstype').length > 0)
				{	
					this.model.get('options').forEach(function(model) {

						if(model.get('cartOptionId') == 'custcol_appf_custom_uom_website')
						{	
							model.set('value',{
								label: value ? value : unitstype.value
							,	internalid: value ? value : unitstype.value
							});
							self.model.set('custcol_appf_custom_uom_website', value ? value : unitstype.value);
						}
						if(model.get('cartOptionId') == 'custcol_appf_custom_uom_label_website')
						{	model.set('value',{
								label: text ? text : unitstype.text
							,	internalid: text ? text : unitstype.text
							});
							self.model.set('custcol_appf_custom_uom_label_website', text ? text : unitstype.text);
						}
						if(model.get('cartOptionId') == 'custcol_appf_custom_uom_price_website')
						{
							model.set('value',{
							label: customprice
							,	internalid: customprice
							});
							self.model.set('custcol_appf_custom_uom_price_website', customprice);
						}
					});
				}

			}
			/// customization for wishlist in leafreak///
			var self = this
			,	$el = jQuery(e.target)
			,	value = $el.val()
			,	saleUnitObj = _.findWhere(this.model.get('item').get('unitstype'), {saleUnit: true});
			if(this.model.get('item').has('unitstype'))
			{
				this.model.get('item').get('unitstype').forEach(function(unit){

				if(unit.id == value)
				{
					var onlinePrice = self.model.getPrice()
				//	,	customprice = (onlinePrice ? (onlinePrice.price * unit.convertionRate) : '') ;
					,	customprice = (onlinePrice ? ( (onlinePrice.price / saleUnitObj.convertionRate) * unit.convertionRate ) : '');
					self.model.get('item').set('customprice',customprice);
				}
				});
			}
		}	
	,	setUnitType: function()
		{
			var self = this;
			_.each( this.model.get('options').models, function(model){
				var optModel = _.find(self.model.get('item').get('unitstype'),function(unit){
				return unit.isSelected == true;
			})
			
			,	saleUnit = _.find(self.model.get('item').get('unitstype'),function(unit){
					return unit.saleUnit == true;
				});
			var unitId = optModel ? optModel.id : (saleUnit ? saleUnit.id :(!_.isUndefined(self.model.get('item').get('unitstype'))?(self.model.get('item').get('unitstype').length>0 ? self.model.get('item').get('unitstype')[0].id : '' ) : ''));
			var unitName = optModel ? optModel.name : (saleUnit ? saleUnit.name :(!_.isUndefined(self.model.get('item').get('unitstype'))?(self.model.get('item').get('unitstype').length>0 ? self.model.get('item').get('unitstype')[0].name : '' ) : ''));
			if(model.get('cartOptionId') == 'custcol_appf_custom_uom_website')
			{
				model.set('value', {
					label:	unitId
				,	internalid: unitId
				});
				self.model.set('custcol_appf_custom_uom_website', unitId );
			}
			if(model.get('cartOptionId') == 'custcol_appf_custom_uom_label_website')
			{
				model.set('value', {
					label:	unitName
				,	internalid: unitName
				});
				self.model.set('custcol_appf_custom_uom_label_website', unitName );
			}
			if(model.get('cartOptionId') == 'custcol_appf_custom_uom_price_website')
			{
				var customprice = self.model.get('customprice')
				,	onlineprice = self.model.getPrice().price;
				customprice = customprice ? customprice.toString() : customprice;
				onlineprice = onlineprice ? onlineprice.toString() : onlineprice;

				model.set('value', {
				label:	customprice ? customprice : onlineprice
				,	internalid: customprice ? customprice : onlineprice
				});
				self.model.set('custcol_appf_custom_uom_price_website', (customprice || onlineprice) );
			}

			});
		}
		//@method getContext @returns ReorderItems.Actions.Quantity.View.Context
	,	getContext: function()
		{
			if(this.isIvaluaLogin)
			{
				this.setUnitType();
			}
			var item = this.line.get('item')
			,	minimum_quantity = item.get('_minimumQuantity', true) || 1
			,	maximum_quantity = item.get('_maximumQuantity', true) || 0
			,	itemQuantity = this.line.get('quantity') > minimum_quantity ? this.line.get('quantity') : minimum_quantity;
			jQuery('[name="unitstype"]').trigger('change');

			//@class ReorderItems.Actions.Quantity.View.Context
			return {
					//@propery {ReorderItems.Model} line
					line: this.line
					//@propery {Boolean} showQuantityInput
				,	showQuantityInput: !!item.get('_isPurchasable')
					//@propery {String} lineId
				,	lineId: this.line.get('internalid')
					//@propery {Number} itemQuantity
				,	itemQuantity: itemQuantity
					//@propery {Boolean} showLastPurchased
				,	showLastPurchased: !!this.line.get('trandate')
					//@property {Boolean} showMinimumQuantity
				,	showMinimumQuantity: minimum_quantity > 1
					//@property {Integer} minimumQuantity
				,	minimumQuantity: minimum_quantity
					//@property {Boolean} showMinimumQuantity
				,	showMaximumQuantity: maximum_quantity !== 0
					//@property {Integer} minimumQuantity
				,	maximumQuantity: maximum_quantity
				
				,	unitstype: item.get('unitstype') || []
				
				,	uomExists:(item.get('unitstype') && item.get('unitstype').length > 0)?true:false
			};
		}
	});
});
